var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-center"},[_c('b-spinner',{staticStyle:{"width":"4rem","height":"4rem","margin-top":"15px"},attrs:{"label":"Loading"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }